module.exports = __webpack_public_path__ + "d55098430cd81a241e4df1b78c38b040.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/dominik-kundel.jpg
// module id = 440
// module chunks = 0